import React, { useRef, useState } from 'react'
import { submitContactForm } from '../services/emailService'

function Contact() {
  const form = useRef(null)
  const [status, setStatus] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    setStatus('sending')

    submitContactForm(form.current, 'contact-page')
      .then(() => {
        setStatus('success')
        form.current.reset()
      })
      .catch(() => {
        setStatus('error')
      })
  }

  return (
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Contact Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              {/* <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li> */}
              {/* <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Contact
              </li> */}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Contact Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <h1 className="display-1 fw-bold" style={{ lineHeight: 1 }}>
                Contact
                <br />
                Us
              </h1>
            </div>
            <div className="col-lg-8">
              <div className="row gx-4 gy-4">
                <div className="col-md-4 d-flex">
                  <div>
                    <div style={{ width: 64, height: 64, borderRadius: 12, background: '#dff6fb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-plus text-primary" style={{ fontSize: 22 }} />
                    </div>
                  </div>
                  <div className="ms-3">
                    <h5 className="mb-2">Location</h5>
                    <p className="mb-0">Ceylonsman (Private) Limited<br />No: 199/D, Oruwala,<br />Athurugiriya (10150), Sri Lanka</p>
                  </div>
                </div>
                <div className="col-md-4 d-flex">
                  <div>
                    <div style={{ width: 64, height: 64, borderRadius: 12, background: '#dff6fb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-phone text-primary" style={{ fontSize: 22 }} />
                    </div>
                  </div>
                  <div className="ms-3">
                    <h5 className="mb-2">Contact Detail</h5>
                    <p className="mb-0">info@ceylonsman.com<br />+94 71 188 7338<br />Available 24/7</p>
                  </div>
                </div>
                <div className="col-md-4 d-flex">
                  <div>
                    <div style={{ width: 64, height: 64, borderRadius: 12, background: '#dff6fb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="fa fa-globe text-primary" style={{ fontSize: 22 }} />
                    </div>
                  </div>
                  <div className="ms-3">
                    <h5 className="mb-2">Social Accounts</h5>
                    <p className="mb-0">
                      <i className="fab fa-instagram me-3" />
                      <i className="fab fa-facebook-f me-3" />
                      <i className="fab fa-youtube" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}

       <section className="contact-section container-fluid p-0">
      <div className="row g-0">
  {/* RIGHT IMAGE */}
        <div className="col-lg-6">
          <div
            className="image-side-right"
            style={{
              backgroundImage: "url('/assets/img/contact-us-right.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '420px',
              width: '100%',
            }}
          />
        </div>
        {/* LEFT FORM */}
        <div className="col-lg-6 p-5 form-area">
          <h1 className="form-title">
            We'd love to hear <br /> from you!
          </h1>

          <form ref={form} onSubmit={handleSubmit} className="mt-4">

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>First Name*</label>
                <input
                  name="user_firstname"
                  type="text"
                  className="form-control form-input"
                  placeholder="Your First Name"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Last Name*</label>
                <input
                  name="user_lastname"
                  type="text"
                  className="form-control form-input"
                  placeholder="Your Last Name"
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label>Email*</label>
                <input
                  name="user_email"
                  type="email"
                  className="form-control form-input"
                  placeholder="Email Address"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label>Contact Number*</label>
                <input
                  name="contact_number"
                  type="text"
                  className="form-control form-input"
                  placeholder="Contact Number"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label>Tell us about your travel plans*</label>
              <textarea
                name="message"
                className="form-control form-input"
                rows="3"
                placeholder="Enter Your Message"
                required
              />
            </div>

            {/* CHECKBOX */}
            <div className="form-check mb-3">
              <input name="subscribe" type="checkbox" className="form-check-input" />
              <label className="form-check-label">
                I want to receive the latest travel news, insights and offers to my inbox.
              </label>
            </div>

            {/* PRIVACY TEXT */}
            <p className="privacy-text">
              By providing my contact details and clicking 'Submit', I consent to being
              contacted via phone, SMS, and email with travel-related information.
              No purchase is necessary. We respect your <span>privacy</span>.
            </p>

            {/* SUBMIT BUTTON */}
            <button type="submit" className="submit-btn">Submit</button>

            {status === 'sending' && (
              <p className="text-secondary mt-3">Sending message...</p>
            )}
            {status === 'success' && (
              <p className="text-success mt-3">Thanks! Your message has been sent.</p>
            )}
            {status === 'error' && (
              <p className="text-danger mt-3">Oops! Something went wrong. Please try again.</p>
            )}

          </form>
        </div>

      
      </div>
    </section>
    </div>
  )
}

export default Contact
